import React, { useState, useEffect } from 'react';
import { getBlogs, getBlogBySlug } from '../admin/services/blogService';
import { subscribeToSettings } from '../admin/services/settingsService';
import { Link, useParams } from 'react-router-dom';

const SocialIcon = ({ platform }) => {
  const icons = {
    facebook: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
    ),
    twitter: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.84 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/></svg>
    ),
    instagram: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>
    ),
    youtube: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505a3.017 3.017 0 00-2.122 2.136C0 8.055 0 12 0 12s0 3.945.501 5.814a3.017 3.017 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.945 24 12 24 12s0-3.945-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
    ),
    linkedin: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.225 0z"/></svg>
    ),
    github: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"/></svg>
    ),
    tiktok: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.9-.32-1.92-.35-2.81-.07-.75.24-1.41.69-1.84 1.34s-.62 1.45-.58 2.22c.04.59.21 1.19.53 1.7.54.81 1.44 1.39 2.39 1.5.76.08 1.54-.11 2.19-.51.84-.45 1.42-1.3 1.61-2.22.05-.33.05-.66.04-.99.02-4.02.01-8.04.02-12.06z"/></svg>
    ),
    link: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71"></path><path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71"></path></svg>
    )
  };

  return icons[platform] || icons.link;
};

export default function Blog() {
  const { slug } = useParams();
  const [blogs, setBlogs] = useState([]);
  const [currentPost, setCurrentPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [settings, setSettings] = useState({ title: 'ALL BLACK SCREEN' });

  useEffect(() => {
    // Subscribe to settings for title
    const unsub = subscribeToSettings((data) => {
      setSettings(data || { title: 'ALL BLACK SCREEN' });
    });

    return () => unsub && unsub();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      if (slug) {
        const post = await getBlogBySlug(slug);
        setCurrentPost(post);
        if (post) {
          document.title = `${post.title} - ${settings.seoTitle || settings.title || 'ALL BLACK SCREEN'}`;
        }
      } else {
        const data = await getBlogs();
        setBlogs(data);
        document.title = `Blog - ${settings.seoTitle || settings.title || 'ALL BLACK SCREEN'}`;
      }
      setLoading(false);
    };
    fetchData();
  }, [slug, settings.title]);

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-950 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  // Single Post View
  if (slug && currentPost) {
    return (
      <div className="min-h-screen bg-white">
        <header className="bg-slate-950 py-20 px-6 text-center border-b border-slate-900">
          <div className="max-w-4xl mx-auto space-y-6">
            <Link to="/blog" className="text-blue-400 hover:text-white transition-colors text-sm font-bold uppercase tracking-widest flex items-center justify-center gap-2">
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
              All Posts
            </Link>
            <h1 className="text-4xl md:text-6xl font-black text-white uppercase tracking-tighter leading-none">
              {currentPost.title}
            </h1>
            <div className="flex items-center justify-center gap-4 text-sm text-slate-400 font-bold uppercase tracking-wider">
              <span>{currentPost.createdAt?.toDate ? new Date(currentPost.createdAt.toDate()).toLocaleDateString() : 'Recent'}</span>
              <span>•</span>
              <span>By {currentPost.author || 'Admin'}</span>
            </div>
          </div>
        </header>

        <main className="max-w-4xl mx-auto px-6 py-16">
          {currentPost.featuredImage && (
            <img 
              src={currentPost.featuredImage} 
              alt={currentPost.title} 
              className="w-full h-auto rounded-3xl shadow-2xl mb-12 object-cover max-h-[500px]" 
            />
          )}
          <div 
            className="prose prose-slate max-w-none text-slate-700 leading-relaxed text-lg whitespace-pre-wrap"
            dangerouslySetInnerHTML={{ __html: currentPost.content }}
          />
        </main>

        <footer className="bg-slate-50 py-12 border-t border-slate-100 text-center">
          <p className="text-slate-400 text-sm">
            © {new Date().getFullYear()} {settings.title}. All rights reserved.
          </p>
        </footer>
      </div>
    );
  }

  // Blog Grid View
  return (
    <div className="min-h-screen bg-white">
      <header className="bg-slate-950 py-24 px-6 text-center border-b border-slate-900">
        <div className="max-w-4xl mx-auto space-y-6 animate-fade-in">
          <Link to="/" className="text-blue-400 hover:text-white transition-colors text-sm font-bold uppercase tracking-widest flex items-center justify-center gap-2">
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Back to Home
          </Link>
          <h1 className="text-5xl md:text-7xl font-black text-white uppercase tracking-tighter">
            The Blog
          </h1>
          <p className="text-slate-400 text-lg md:text-xl font-medium max-w-2xl mx-auto">
            Insights, updates, and more from {settings.title}.
          </p>
        </div>
      </header>

      <main className="max-w-6xl mx-auto px-6 py-20">
        {blogs.length === 0 ? (
          <div className="py-20 text-center">
            <p className="text-slate-400 text-xl font-medium">No posts found yet. Stay tuned!</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogs.map((blog, index) => (
              <Link 
                key={blog.id} 
                to={`/blog/${blog.slug || blog.id}`}
                className="group flex flex-col bg-white rounded-3xl border border-slate-100 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 overflow-hidden"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="aspect-video w-full bg-slate-100 overflow-hidden">
                  {blog.featuredImage ? (
                    <img 
                      src={blog.featuredImage} 
                      alt={blog.title} 
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" 
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center text-slate-300">
                      <svg className="w-12 h-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                      </svg>
                    </div>
                  )}
                </div>
                <div className="p-6 flex-1 flex flex-col justify-between space-y-4">
                  <div className="space-y-3">
                    <div className="flex items-center gap-3 text-[10px] font-black uppercase tracking-widest text-blue-500">
                      <span>{blog.createdAt?.toDate ? new Date(blog.createdAt.toDate()).toLocaleDateString() : 'Recent'}</span>
                      <span className="w-1 h-1 bg-slate-300 rounded-full"></span>
                      <span>By {blog.author || 'Admin'}</span>
                    </div>
                    <h2 className="text-xl font-bold text-slate-900 group-hover:text-blue-600 transition-colors uppercase leading-tight line-clamp-2">
                      {blog.title}
                    </h2>
                  </div>
                  <div className="flex items-center text-sm font-bold text-slate-400 group-hover:text-blue-500 transition-colors">
                    Read Post 
                    <svg className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </main>

        <footer className="bg-slate-50 py-16 border-t border-slate-100 text-center">
          <div className="flex justify-center space-x-6 mb-8">
            {settings.socialLinks?.map((link) => (
              <a 
                key={link.id} 
                href={link.url} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-slate-400 hover:text-slate-900 transition-all hover:-translate-y-1"
                title={link.platform}
              >
                <SocialIcon platform={link.platform} />
              </a>
            ))}
          </div>
          <p className="text-slate-400 text-sm font-medium">
            © {new Date().getFullYear()} {settings.title}. All rights reserved.
          </p>
        </footer>
    </div>
  );
}
